import { pixelToGridPosition } from "../../utils/gridPosition";
import { Size } from "../../types";
import { canvasPos } from "../../utils/canvasPos";

/*
 * @return the rect area formed by mouse drag action. The unit
 *         will be in grid unit
 */
export function calcPreviewRect(m1: MouseEvent, m2: MouseEvent) {
  const p1 = canvasPos(m1);
  const p2 = canvasPos(m2);

  const left = Math.min(p1.x, p2.x);
  const right = Math.max(p1.x, p2.x);
  const top = Math.min(p1.y, p2.y);
  const bottom = Math.max(p1.y, p2.y);

  const topLeft = pixelToGridPosition({ x: left, y: top }, Math.floor);
  const bottomRight = pixelToGridPosition({ x: right, y: bottom }, Math.ceil);

  const size = {
    width: Math.max(bottomRight.x - topLeft.x, 1),
    height: Math.max(bottomRight.y - topLeft.y, 1),
  };

  return { position: topLeft, size };
}

type Rect = ReturnType<typeof calcPreviewRect>;

export function isOverlapping(rectA: Rect, rectB: Rect) {
  const a = {
    left: rectA.position.x,
    right: rectA.position.x + rectA.size.width,
    top: rectA.position.y,
    bottom: rectA.position.y + rectA.size.height,
  };

  const b = {
    left: rectB.position.x,
    right: rectB.position.x + rectB.size.width,
    top: rectB.position.y,
    bottom: rectB.position.y + rectB.size.height,
  };

  if (
    a.left >= b.right ||
    a.right <= b.left ||
    a.top >= b.bottom ||
    a.bottom <= b.top
  ) {
    return false;
  }

  return true;
}

type CreateType = "text-block" | "no-block" | "create-menu-block";

export function deriveCreateType(size: Size): CreateType {
  if (size.width < 2 || size.height < 2) {
    return "no-block";
  }

  if (size.height < 5 || size.width < 5) {
    return "text-block";
  }

  return "create-menu-block";
}
